export const ORIGINS = {};

export const PRODUCT_TYPES = {};

export const PRODUCT_TYPES_NAMES = {};
